import * as React from 'react';
import * as classNames from 'classnames';

import './styles.scss';
import Icon from '../Icon';

export interface INonIdealStateProps {
    /** Text to display */
    title: string;
    /** Longer description to display */
    description?: string;
    /** One of bundled icons to display */
    icon?:
        'illustration-nonideal' |
        'illustration-404' |
        'illustration-emptylist' |
        'illustration-fatal' |
        'illustration-maintenance' |
        'illustration-nofilter' |
        'illustration-nomobile' |
        'illustration-offline';
    /** Custom offset for different icons */
    iconOffset?: [number, number];
    /** Custom addon to display at the bottom (e.g. button) */
    addOn?: React.ReactNode;
    /** Intent to use */
    intent?: 'danger' | 'success' | 'warning';
    /** className to append */
    className?: string;
}

interface IState {
}

/**
 * NonIdealStates visually highlight important content for the user.
 */
export default class NonIdealState extends React.Component<INonIdealStateProps, IState> {
    static displayName: string = 'NonIdealState';

    constructor (props: INonIdealStateProps) {
        super(props);
    }

    render () {
        return (
            <div className={classNames('nonidealstate', this.props.className)}>
                <div className="nonidealstate-spacer"/>
                <div className={classNames('nonidealstate')}>
                    <div className="nonidealstate-inner">
                        <Icon
                            kind="illustration-bg"
                            width={185}
                            height={185}
                            wrapperClassName={classNames('nonidealstate-bg', this.props.intent ? 'intent-' + this.props.intent : undefined)}
                        />
                        <div
                            style={{ transform: this.props.iconOffset ? 'translate(' + this.props.iconOffset[0] + 'px' + ',' + this.props.iconOffset[1] + 'px' + ')' : 'translate(0, 0)' }}
                            className="nonidealstate-icon">
                            <Icon
                                width={200}
                                height={200}
                                kind={this.props.icon ? this.props.icon : 'illustration-nonideal'}
                            />
                        </div>
                    </div>
                    <div className="nonidealstate-content">
                        <div className="nonidealstate-title">{this.props.title}</div>
                        {!!this.props.description && (
                            <div className="nonidealstate-description">{this.props.description}</div>
                        )}
                    </div>
                    {!!this.props.addOn && (
                        <div className="nonidealstate-addon">
                            {this.props.addOn}
                        </div>
                    )}
                </div>
                <div className="nonidealstate-spacer"/>
            </div>
        );
    }
}
